<template>
  <div class="">
    <h3 class="font-bold my-3">محتوا</h3>
    <div class="mt-3" v-for="(item,key) in component.slots" :key="generateRandomString">

      <label class="block mb-2 text-sm font-medium text-gray-900 gray:text-gray-400">{{ key }}</label>
      <textarea id="message" rows="4"
                v-model="component.slots[key].text"
                class="form-control"></textarea>

    </div>
  </div>
</template>

<script>
import {generateRandomString} from "@/store/Modules/Site";

export default {
  name: "NormalComponentContentManager",
  props: {
    component: {}
  },
  computed: {
    generateRandomString,
  },
}
</script>

<style scoped>

</style>